import { useCallback } from 'react';
import { getCenter } from 'ol/extent';

const identity = (feature) => feature;

const useFeatureSelection = ({
    mapRef,
    overlayRef,
    featureToSelection = identity,
    onSelectionChange,
    hitTolerance = 0,
    layerFilter,
}) => {
    return useCallback(
        (evt) => {
            const map = mapRef.current;
            if (!map) return;

            const feature = map.forEachFeatureAtPixel(
                evt.pixel,
                (f) => f,
                {
                    hitTolerance,
                    layerFilter,
                }
            );

            if (feature) {
                const coord = getCenter(feature.getGeometry().getExtent());
                const selection = featureToSelection(feature);
                onSelectionChange?.(selection, feature, coord);
            } else {
                overlayRef?.current?.setPosition(undefined);
                onSelectionChange?.(null, null, null);
            }
        },
        [featureToSelection, hitTolerance, layerFilter, mapRef, onSelectionChange, overlayRef]
    );
};

export default useFeatureSelection;
